import { Connection, PublicKey, LAMPORTS_PER_SOL } from "@solana/web3.js";
import { getAccount, TOKEN_PROGRAM_ID, TOKEN_2022_PROGRAM_ID } from "@solana/spl-token";

export const SOLANA_PROGRAM_ID = process.env.NEXT_PUBLIC_SOLANA_PROGRAM_ID || "";

export const getSolanaBalance = async (
  walletAddress: string,
  tokenAddress: string,
  decimals: number
): Promise<number> => {
  try {
    const solanaRpcUrl =
      typeof window !== "undefined"
        ? `${window.location.origin}/api/rpc?chain=solana`
        : "https://api.mainnet-beta.solana.com";
    const CONNECTION = new Connection(solanaRpcUrl, {
      commitment: "confirmed",
    });
    const ownerPubkey = new PublicKey(walletAddress);

    // If tokenAddress is native SOL, get native SOL balance
    if (tokenAddress === "11111111111111111111111111111111") {
      const balance = await CONNECTION.getBalance(ownerPubkey);
      return balance / LAMPORTS_PER_SOL; // Convert lamports to SOL
    }

    // Create PublicKey objects
    const mintPubkey = new PublicKey(tokenAddress);

    // Detect token program from mint's owner (Token-2022 vs classic SPL)
    const mintInfo = await CONNECTION.getAccountInfo(mintPubkey);
    if (!mintInfo) {
      return 0;
    }
    const programId = mintInfo.owner.equals(TOKEN_2022_PROGRAM_ID)
      ? TOKEN_2022_PROGRAM_ID
      : TOKEN_PROGRAM_ID;

    // Find the token account using the correct program
    const tokenAccounts = await CONNECTION.getTokenAccountsByOwner(
      ownerPubkey,
      {
        mint: mintPubkey,
        programId,
      }
    );

    if (tokenAccounts.value.length === 0) {
      return 0;
    }

    // Get the token account info (programId must match for getAccount)
    const tokenAccount = await getAccount(
      CONNECTION,
      tokenAccounts.value[0].pubkey,
      undefined,
      programId
    );

    // Return the balance (adjusted for decimals)
    return Number(tokenAccount.amount) / 10 ** decimals;
  } catch (error) {
    console.error("Error fetching Solana balance:", error);
    return 0;
  }
};

export const isSolanaAddress = (address: string): boolean => {
  try {
    new PublicKey(address);
    return true;
  } catch (error) {
    return false;
  }
};
